<template>
	<el-row :gutter="20" v-loading="loading">
		<el-col :span="4">
			<div>
				<el-statistic :precision="0" :value="statics.xwoutputcount + statics.nazhioutputcount"
					title="销项数量"></el-statistic>
			</div>
		</el-col>
		<el-col :span="4">
			<div>
				<el-statistic :precision="0" :value="statics.xwoutputcustomercount + statics.nazhioutputcustomercount"
					title="销项客户数"></el-statistic>
			</div>
		</el-col>
		<el-col :span="4">
			<div>
				<el-statistic group-separator="," :precision="2"
					:value="statics.xwoutputamount + statics.nazhioutputamount" title="销项金额"></el-statistic>
			</div>
		</el-col>
		<el-col :span="4">
			<div>
				<el-statistic :precision="0" :value="statics.nazhiinputcount" title="进项数量"></el-statistic>
			</div>
		</el-col>
		<el-col :span="4">
			<div>
				<el-statistic :precision="0" :value="statics.nazhiinputcustomercount" title="进项客户数"></el-statistic>
			</div>
		</el-col>
		<el-col :span="4">
			<div>
				<el-statistic group-separator="," :precision="2" :value="statics.nazhiinputamount"
					title="进项金额"></el-statistic>
			</div>
		</el-col>
	</el-row>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		props: {

		},
		data() {
			return {
				loading:false,
				statics:{
					xwoutputcount:0,
					nazhioutputcount:0,
					xwoutputcustomercount:0,
					nazhioutputcustomercount:0,
					xwoutputamount:0,
					nazhioutputamount:0,
					nazhiinputcount:0,
					nazhiinputcustomercount:0,
					nazhiinputamount:0,
				}
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {


		},
		computed: {

		},

		methods: {
			load(updateForm) {
				this.loading = true
				this.$api.invoice.statics(updateForm).then((res) => {
					this.statics = res
					this.loading = false
				})
			}

		},
		components: {

		}
	}
</script>